import { parseDice, parseDoliDanaRdesc } from './resultParsers';

export default function DoliDanaResult({ detail }) {
  const diceValues = parseDice(detail?.card);
  const rdesc = parseDoliDanaRdesc(detail?.rdesc);
  // A MATCH result is "<turn>#<winner>" ("Player B#Player B"); a ROLL result
  // has six parts. Reference: the match shows Win (not Any Pair), and a market
  // with no value is not listed (user 2026-10-15).
  const parts = String(detail?.rdesc || '').split('#');
  const rows = (parts.length === 2
    ? [['Turn', parts[0]], ['Win', parts[1]]]
    : [
      ['Turn', rdesc.turn],
      ['Any Pair', rdesc.anyPair],
      ['Particulat Pair', rdesc.particularPair],
      ['Sum Total', rdesc.sumTotal],
      ['Odd/Even', rdesc.oddEven],
      ['Lucky 7', rdesc.lucky7],
    ]).filter(([, value]) => String(value ?? '').trim() !== '');

  return (
    <div className="row row5 worli-result">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center w-100">
            <div className="casino-result-cards">
              {diceValues.map((n, i) => (
                <div key={i} className="casino-result-cards-item">
                  <img src={`https://wver.sprintstaticdata.com/v230/static/front/img/dice${n}.png`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-5">
        <div className="casino-result-desc">
          {rows.map(([label, value]) => (
            <div key={label} className="casino-result-desc-item"><div>{label}</div><div>{value}</div></div>
          ))}
        </div>
      </div>
    </div>
  );
}
